import { render, staticRenderFns } from "./ProductMarketplaceLink.vue?vue&type=template&id=4530bd95&"
import script from "./ProductMarketplaceLink.vue?vue&type=script&lang=js&"
export * from "./ProductMarketplaceLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports